'use strict'
import { MESSAGE, RESET_INFORMATION } from '../constants/InformationConstants'

const InformationAction = {
	message: function (message) {
		return {
			type: MESSAGE,
			message: message
		}
	},
	reset: function () {
		return {
			type: RESET_INFORMATION
		}
	}
}

export default InformationAction



// WEBPACK FOOTER //
// ./src/home/actions/InformationAction.js